import {
  getProductStartDate,
  getProductStartPeriod
} from '../../../../../MediaOrderCreate/MediaOrderCreateForm/ContractCreateForm/helpers/periodHelpers'

import {
  formatNewPeriods,
  formatPeriodOptions
} from '../../../ProductsTable/cols/DatesCol/DatesCell/EditPeriods/Reusable/helpers'
import calculateProductPrice from '../../../ProductsTable/helpers/calculateProductPrice'
import { handleCustomPeriodSelection } from '../../../ProductsTable/cols/DatesCol/DatesCell/EditPeriods/CustomDatePeriodSelector/handleCustomPeriodSelection'
import { formatDateToBE } from '../../../../../../../../constants/dates'

import { PERIOD_DAYS_QUANTITY } from '../../../../../../../../constants/mediaOrders'

import {
  CUSTOM_PRODUCT_PRICE,
  MEDIA_PRODUCTS,
  ORIGINAL_PRODUCT_PRICE,
  PRODUCT_GROUPED_PUBLICATIONS_DATES,
  PRODUCT_PERIODS_DATES
} from '../../../../fields'
import { findLastContinuousPeriod } from '../../../ProductsTable/cols/DatesCol/DatesCell/EditPeriods/DatePickerPeriodSelector/helpers'

const getSelectedPeriodsValues = ({
  productData,
  dateRange,
  inventoryData,
  supportCustomDates,
  beforeAfterPercentage,
  newProductValues
}) => {
  const startDate = formatDateToBE(dateRange.startDate)
  const endDate = formatDateToBE(dateRange.endDate)

  const productPeriod = productData.period
  const productStartDate = getProductStartDate(productData)
  const productStartPeriodDate = getProductStartPeriod(productPeriod, productStartDate)

  // periodOptions are generated based on product inventory period
  const periodOptions = formatPeriodOptions({ productStartPeriodDate, productPeriod, inventory: inventoryData })

  // filter out selected periods:
  const availablePeriods = periodOptions.filter(period => {
    // overdue are not available to select by user
    return !period.isDisabled && !period.overdue
  })

  const daysInPeriod = PERIOD_DAYS_QUANTITY[productPeriod]
  const additionalAvailableDays = beforeAfterPercentage ? Math.round(daysInPeriod * beforeAfterPercentage) : 0

  const newPeriods = supportCustomDates
    ? handleCustomPeriodSelection({
        endDate,
        startDate,
        availablePeriods,
        additionalAvailableDays,
        logWarning: false
      })
    : handleRegularPeriodSelection({
        availablePeriods,
        selectedStartDate: dateRange.startDate,
        productPeriod,
        startDate,
        endDate
      })

  return setNewPeriodsValues({ newPeriods, newProductValues, startDate, endDate })
}

const handleRegularPeriodSelection = ({ availablePeriods, selectedStartDate, productPeriod, startDate, endDate }) => {
  if (availablePeriods.length === 0) {
    return []
  } else {
    // check if periods cover the whole date range
    const firstPeriodStartDate = availablePeriods[0].date_start
    const lastPeriodEndDate = availablePeriods[availablePeriods.length - 1].date_end
    const isFullPeriod = firstPeriodStartDate === startDate && lastPeriodEndDate === endDate

    if (isFullPeriod) {
      // when the start and end dates match with selected range - check if the selected periods is continuous i.e. no gaps
      const lastContinuousPeriod = findLastContinuousPeriod(availablePeriods, selectedStartDate, productPeriod)
      const isContinuous = lastContinuousPeriod?.date_end === endDate

      return isContinuous ? availablePeriods : []
    } else {
      return []
    }
  }
}

const setNewPeriodsValues = ({ newPeriods, newProductValues, startDate, endDate }) => {
  const hasPeriods = newPeriods.length > 0
  // if there are no periods selected, do not update the values
  if (hasPeriods === false) {
    return newProductValues
  } else {
    const { sortedNewPeriods, sortedNewGroupPeriods } = formatNewPeriods({ newPeriods })
    const periodStartDate = sortedNewPeriods[0]?.date_start
    const periodEndDate = sortedNewPeriods[sortedNewPeriods.length - 1].date_end

    if (periodStartDate === startDate && periodEndDate === endDate) {
      // when new periods cover the whole date range, add them
      const calculatedPrice = calculateProductPrice(sortedNewPeriods, 1, 0)
      const newTotalProductPrice = calculatedPrice.totalPrice

      return {
        ...newProductValues,
        // new periods:
        [PRODUCT_PERIODS_DATES]: sortedNewPeriods,
        [PRODUCT_GROUPED_PUBLICATIONS_DATES]: sortedNewGroupPeriods,
        // reset prices:
        [ORIGINAL_PRODUCT_PRICE]: newTotalProductPrice,
        [CUSTOM_PRODUCT_PRICE]: newTotalProductPrice
      }
    } else {
      // in other case ignore adding
      return newProductValues
    }
  }
}

export const initialProductPeriodsValues = {
  [PRODUCT_PERIODS_DATES]: [],
  [PRODUCT_GROUPED_PUBLICATIONS_DATES]: [],
  [ORIGINAL_PRODUCT_PRICE]: 0,
  [CUSTOM_PRODUCT_PRICE]: 0
}
export const handlePeriodsSelection = ({
  products,
  productsInventory,
  dateRange,
  selectedController,
  setFieldValue,
  startIndex
}) => {
  const supportCustomDates = selectedController?.custom_booking_dates
  const beforeAfterPercentage = supportCustomDates ? selectedController?.before_percentage || 0 : 0

  products.forEach((product, productIndex) => {
    const productData = product.data
    // startIndex is used to calculate correct product path when there were products added before
    const productPath = `${MEDIA_PRODUCTS}[${startIndex + productIndex}]`

    const inventoryData = productsInventory?.find(
      inv => String(inv.media_product) === String(productData.id)
    )?.inventories

    let newProductValues = {
      // spread to copy object values instead of object reference usage
      ...initialProductPeriodsValues
    }
    let updatedProductValues = {}
    if (inventoryData) {
      updatedProductValues = getSelectedPeriodsValues({
        productData,
        dateRange,
        inventoryData,
        supportCustomDates,
        beforeAfterPercentage,
        newProductValues
      })
    }

    // always set new periods values to reset previous selection:
    setFieldValue(productPath, {
      ...product,
      ...updatedProductValues,
      isInventoryLoading: false
    })
  })
}
